export const PKCE_CONSTANTS = {
  CONTENT_TYPE: 'application/x-www-form-urlencoded',
  CODE_CHALLENGE_METHOD: 'S256',
  NONCE_RANDOM_CODE_GENERATE_LENGTH: 16,
  STATE_RANDOM_CODE_GENERATE_LENGTH: 28,
  DEFAULT_RANDOM_CODE_GENERATE_LENGTH: 8,
  AUTHORIZATION_CODE: 'authorization_code',
  REFRESH_TOKEN: 'refresh_token',
  API_ACCEPT_HEADER_VALUE: 'resource=3.1, protocol=1.0',
};
